import React, { FC, useMemo, useState } from 'react'

import { Icon, Txt } from 'src/components/atoms'
import { UpsertAllowedIp } from 'src/components/organisms'

import { AllowedIpEntity, NewAllowedIpId } from 'src/types'

type Props = {
  allowedIp: AllowedIpEntity | NewAllowedIpId
  afterCrud: () => void
  deleteNewItem: (newItemId: NewAllowedIpId) => void
  className?: string
}

export const AllowedIpListItem: FC<Props> = ({
  allowedIp,
  afterCrud,
  deleteNewItem,
  className,
}) => {
  const [isEditMode, setIsEditMode] = useState(typeof allowedIp === 'string')

  const nowAllowedIp = useMemo(() => {
    return typeof allowedIp === 'string' ? null : allowedIp
  }, [allowedIp])

  const handleAfterCrud = async () => {
    await afterCrud()
    setIsEditMode(false)
  }

  return (
    <div className={className}>
      {isEditMode ? (
        <UpsertAllowedIp
          allowedIp={typeof allowedIp === 'string' ? null : allowedIp}
          afterCrud={handleAfterCrud}
          deleteNewItem={() => deleteNewItem(typeof allowedIp === 'string' ? allowedIp : '')}
          onCancel={() => setIsEditMode(false)}
        />
      ) : (
        <div className="tw-flex tw-items-center tw-gap-r2 tw-h-[3.57rem]">
          <div className="tw-flex tw-items-center tw-gap-r2 tw-w-full">
            <div className="tw-w-[11rem] tw-shrink-0">
              <Txt>{nowAllowedIp?.ip}</Txt>
            </div>
            <div className="tw-w-full">
              <Txt sizeType="s" className="tw-text-standardText-secondary">
                概要
              </Txt>
              <Txt className="tw-ml-s-1 tw-mt-s-4">{nowAllowedIp?.description}</Txt>
            </div>
          </div>
          <button
            type="button"
            className="tw-flex tw-w-[1.71rem] tw-shrink-0 tw-cursor-pointer"
            onClick={() => setIsEditMode(true)}
          >
            <Icon
              size="--r2"
              path="settings/soft/line"
              className="tw-text-standardText-secondary hover:tw-text-standardText-primary"
            />
          </button>
        </div>
      )}
    </div>
  )
}
